var React = require('react');

function Volume2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M58.16 18.84C61.9094 22.5905 64.0157 27.6767 64.0157 32.98C64.0157 38.2833 61.9094 43.3694 58.16 47.12M72.28 4.71997C79.7788 12.2211 83.9915 22.3934 83.9915 33C83.9915 43.6065 79.7788 53.7789 72.28 61.28M40 4.99997L20 21H4V45H20L40 61V4.99997Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Volume2.defaultProps = {"width":"88","height":"66","viewBox":"0 0 88 66","fill":"none"};

module.exports = Volume2;

Volume2.default = Volume2;
